export function buildCurrentUserQueryV1(ensureGlobalAdminRole: boolean, ensureOrganizationAdminRole: boolean, ensureAnyAdminRole: boolean)
{
	return {
		'$type': 'TCh.Domain.Organizations.Users.Queries.CurrentUserQueryV1, TCh.Domain.Organizations',
		'EnsureGlobalAdminRole': ensureGlobalAdminRole,
		'EnsureOrganizationAdminRole': ensureOrganizationAdminRole,
		'EnsureAnyAdminRole': ensureAnyAdminRole,
	}
}

export function buildOrganizationAdminCandidatesQueryV1(organizationUnitId: number)
{
	return {
		'$type': 'TCh.Domain.Organizations.Users.Queries.OrganizationAdminCandidatesQueryV1, TCh.Domain.Organizations',
		'OrganizationUnitId': organizationUnitId,
	}
}

export function buildPasswordPolicyQueryV1()
{
	return {
		'$type': 'TCh.Domain.Organizations.Users.Queries.PasswordPolicyQueryV1, TCh.Domain.Organizations',
	}
}

export function buildSearchAllUsersQueryV1(organizationUnitId: number, searchPhrase: string, includeActive: boolean, includeLocked: boolean, includeDeleted: boolean)
{
	return {
		'$type': 'TCh.Domain.Organizations.Users.Queries.SearchAllUsersQueryV1, TCh.Domain.Organizations',
		'OrganizationUnitId': organizationUnitId,
		'SearchPhrase': searchPhrase,
		'IncludeActive': includeActive,
		'IncludeLocked': includeLocked,
		'IncludeDeleted': includeDeleted,
	}
}

export function buildStartupDetailsQueryV1()
{
	return {
		'$type': 'TCh.Domain.Organizations.Users.Queries.StartupDetailsQueryV1, TCh.Domain.Organizations',
	}
}

export function buildUserAccessRequestsQueryV1(organizationUnitId: number, includeRequested: boolean, includeRejected: boolean)
{
	return {
		'$type': 'TCh.Domain.Organizations.Users.Queries.UserAccessRequestsQueryV1, TCh.Domain.Organizations',
		'OrganizationUnitId': organizationUnitId,
		'IncludeRequested': includeRequested,
		'IncludeRejected': includeRejected,
	}
}

export function buildUserDashboardQueryV1()
{
	return {
		'$type': 'TCh.Domain.Organizations.Users.Queries.UserDashboardQueryV1, TCh.Domain.Organizations',
	}
}

export function buildUserQueryV1(userId: string)
{
	return {
		'$type': 'TCh.Domain.Organizations.Users.Queries.UserQueryV1, TCh.Domain.Organizations',
		'UserId': userId,
	}
}

